import { motion } from 'framer-motion';
import React, {  } from 'react';
import MapComponent from './Footer/MapComponent';

const Contact: React.FC = () => {

  return (
    <section id="contact" className="container h-auto overflow-hidden my-10 flex 2xl:rounded-3xl">
      <div className="w-full h-full flex flex-col items-center py-10">
        <div className="contact w-100 h-30 flex flex-col items-center">
          <h1 className="text-4xl font-bold md:text-6xl">
              Kontakt
          </h1>
          <motion.div className="line md:w-[40%] w-[60%] h-[3px] my-2" 
            initial={{scaleX: 0}} 
            whileInView={{scaleX: 1}} 
            transition={{ duration: 1 }}
            viewport={{ margin: "-20%", once: true}} />
        </div>

        <div className="flex sm:flex-row flex-col justify-center gap-20 items-center w-full text-2xl">
          <div className="sm:w-[450px] sm:h-[350px] w-[90vw] mt-4">
            <p>
              Adres: Niecała 14/8,<br/>60-805 Poznań
            </p>
            <hr/>
            <p>
              Email: gabinetcudaki@gmail.com
            </p>
            <hr/>
            <p>
              Telefon: 731 891 432
            </p>
            <hr/>
          </div>
          <div className="sm:w-[350px] sm:h-[350px] h-[90vw] w-[90vw]"><MapComponent/></div>
        </div>
      </div>
    </section>
  );
};

export default Contact;